import { render, staticRenderFns } from "./hoverCopy.vue?vue&type=template&id=19a43283&"
import script from "./hoverCopy.vue?vue&type=script&lang=js&"
export * from "./hoverCopy.vue?vue&type=script&lang=js&"
import style0 from "./hoverCopy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports